import { takeLatest } from "redux-saga/effects";
import * as actionTypes from "../actions/actionTypes";
import {
    getPlayerTypeListSaga, getRolesAndBusinessSaga,
    getUsersListSaga, onOffsetChangeSaga
} from './appUser'
import {
    getMultiReportCardDeatilsSaga, getOnLoadReportCardDtlsSaga,
    getSingleReportCardsDetailsSaga,getMissionsSaga, getTodaysReportCardsDetailsSaga, getMyStatisticsDetailsSaga, getPlayerLevels,
    getPlayerGameSubTypes, getPlayerHitTypes
} from './multipleReportCards'

export function* watchAppUser() {
    
    yield takeLatest(actionTypes.GET_PLAYER_TYPE_LIST, getPlayerTypeListSaga)
    yield takeLatest(actionTypes.GET_ROLES_AND_BUSINESS, getRolesAndBusinessSaga)
    yield takeLatest(actionTypes.GET_USERS_LIST, getUsersListSaga)
    // yield takeLatest(actionTypes.ON_OFFSET_CHANGE, onOffsetChangeSaga)
    yield takeLatest(actionTypes.GET_MULTIPLE_REPORT_CARD_DETAILS, getMultiReportCardDeatilsSaga)
    yield takeLatest(actionTypes.GET_SINGLE_REPORT_CARD_DETAILS, getSingleReportCardsDetailsSaga)
    yield takeLatest(actionTypes.GET_MY_STATISTICS_DETAILS, getMyStatisticsDetailsSaga)
    yield takeLatest(actionTypes.GET_ON_LOAD_REPORT_CARD_DETAILS, getOnLoadReportCardDtlsSaga)
    yield takeLatest(actionTypes.GET_MISSIONS, getMissionsSaga)
    yield takeLatest(actionTypes.GET_PLAYER_LEVELS, getPlayerLevels)
    yield takeLatest(actionTypes.GET_PLAYER_GAME_SUB_TYPES, getPlayerGameSubTypes)
    yield takeLatest(actionTypes.GET_PLAYER_HIT_TYPES, getPlayerHitTypes)
}


/** WEBPACK FOOTER **
 ** ./src/store/sagas/index.js
 **/